if (!customElements.get('specs-desc-manuly')) {
    customElements.define(
        'specs-desc-manuly',
        class SpecsDescManuly extends HTMLElement {

            constructor() {
                super();
            }
            connectedCallback() {
                this.onVariantChangeUnsubscriber = subscribe(
                    PUB_SUB_EVENTS.variantChange,
                    this.handleOptionValueChange.bind(this)
                );
            }

            handleOptionValueChange(data) {
                var prodId = data.data.variant.id;



            }


            getMetaFields(productID) {
                const shopURL = 'https://manuly.de';
                var urlForMeta = shopURL + '/admin/products/' + productID + '/metafields.json';

                fetch(urlForMeta)
                    .then(response => response.json())
                    .then(function(data) {
                        console.log("	--Product Metafields: " + data);
                    })
                    .catch(err => console.log(err))
            }

        });
}